import MainService from "@/services/MainService.js";
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
import msal from "vue-msal";

Vue.use(VueAxios, axios);

Vue.use(msal, {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    tenantId: process.env.VUE_APP_MSAL_TENANT_ID,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
  },
});

export default {
  name: "LoginPage",
  data() {
    const ss = new MainService();
    return {
      ss,
      loginRequest: {
        email: "",
        password: "",
      },
      errorBag: {},
      showEmailField: true, // <- NUEVO: controla si se muestra el input de email
    };
  },
  props: { msg: String },

  methods: {
    extractEmailFromUrl() {
      try {
        const url = new URL(window.location.href);
        let email = url.searchParams.get("email");
        if (!email && window.location.hash.includes("?")) {
          const q = window.location.hash.split("?")[1] || "";
          const params = new URLSearchParams(q);
          email = params.get("email");
        }
        return email
          ? decodeURIComponent(String(email).replace(/\+/g, " ")).trim()
          : "";
      } catch {
        return "";
      }
    },

    toggleEmailEdit() {
      this.showEmailField = true;
      this.$nextTick(() => {
        const el = this.$el.querySelector('input[name="email_visible"]');
        if (el) el.focus();
      });
    },

    login() {
      if (!this.loginRequest.email) {
        this.errorBag = {
          ...this.errorBag,
          email: "Ingrese su correo institucional.",
        };
        this.showEmailField = true;
        return;
      }
      this.errorBag.email = null;

      this.ss
        .login(this.loginRequest)
        .then((result) => {
          localStorage.setItem("persona", JSON.stringify(result.data.data));
          localStorage.setItem("token", JSON.stringify(result.data.token));
          this.$router.push("Profile");
          this.$router.go();
        })
        .catch((error) => {
          this.errorBag =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.errors) ||
            {};
          this.$bvToast.toast("Problema al Iniciar Sesión", {
            title: "Error",
            variant: "danger",
            autoHideDelay: 5000,
          });
        });
    },

    authenticate() {
      if (this.$msal && !this.$msal.isAuthenticated()) this.$msal.signIn();
    },
  },

  mounted() {
    const persona = JSON.parse(localStorage.getItem("persona"));
    if (persona) localStorage.clear();

    const emailFromRoute =
      (this.$route && this.$route.query && this.$route.query.email) || "";
    const emailFromUrl = this.extractEmailFromUrl();
    const email = (emailFromRoute || emailFromUrl || "").trim();

    if (email) {
      this.loginRequest.email = email;
      this.showEmailField = false; // <- si viene por URL, se muestra en “solo lectura” con botón Editar
      this.$nextTick(() => {
        if (this.$refs && this.$refs.pw) this.$refs.pw.focus();
      });
    } else {
      this.showEmailField = true;
    }

    if (this.$msal && this.$msal.isAuthenticated()) {
      const loginTokenRequest = {
        token: this.$msal.data.user.accountIdentifier,
        email: this.$msal.data.user.userName,
      };

      this.ss
        .loginToken365(loginTokenRequest)
        .then((result) => {
          localStorage.setItem("persona", JSON.stringify(result.data.data));
          localStorage.setItem("token", JSON.stringify(result.data.token));
          this.$router.push("/");
          this.$router.go();
        })
        .catch((error) => {
          this.errorBag =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.errors) ||
            {};
          this.$bvToast.toast("Problema al Iniciar Sesión", {
            title: "Error",
            variant: "danger",
            autoHideDelay: 5000,
          });
          if (this.$msal) this.$msal.signOut();
        });
    }
  },
};
